<template>
  <div class="menu-item-wrapper">
    <div class="menu-top">
      <div class="menu-top-icon" style="float: left; ">
        <v-icon :color="$vuetify.theme.themes[theme].text" v-if="!$store.state.menuOpen" @click="openMenu()">menu</v-icon>
        <v-icon :color="$vuetify.theme.themes[theme].text" v-if="$store.state.menuOpen" @click="closeMenu()">chevron_left</v-icon>
      </div>
      <div v-if="$store.state.menuOpen" :style="{color: $vuetify.theme.themes[theme].text}" class="logo-4care-menu" :class="theme"></div>
      <!-- <div v-if="$store.state.menuOpen" :style="{color: $vuetify.theme.themes[theme].text}" style="float: left; font-size: 24px; padding: 7px 0; font-weight: bold; font-family: 'Sofia Pro', sans-serif;">4care Telecom</div> -->
    </div>

    <div class="nav-scroll" :class="userRole">

      <router-link tag="div" class="menu-user-info" :to="`/account`" style="cursor: pointer;">
        <v-list flat  class="ma-0 pa-0" style="background: none;">
          <v-list-item
            class="ma-0 pa-0"
            >
            <v-avatar class="my-0"  size="44" :color="companyPrimaryColor">
              <span class="white--text headline" style="text-transform: uppercase">{{ userAbb }}</span>
            </v-avatar>
            
            <v-list-item-content class="ml-4">
              <v-list-item-title :style="{color: $vuetify.theme.themes[theme].text}" style="font-weight: bold;" >{{userFirstName}} {{userLastName}}</v-list-item-title>
              <!-- <v-list-item-subtitle :style="{color: $vuetify.theme.themes[theme].text}" >{{ userCompanyName }}</v-list-item-subtitle> -->
            </v-list-item-content>

            <v-list-item-icon >
              <v-icon class="mt-0" :color="$vuetify.theme.themes[theme].text">settings</v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list>
      </router-link>


      <!-- <router-link tag="div" class="menu-group first small"  :to="`/home`">
        <div class="menu-group-summary">
          <div class="menu-group-summary-icon">
            <v-icon :color="$vuetify.theme.themes[theme].text">home</v-icon>
          </div>
          <div class="menu-group-summary-text">
            <p class="menu-group-name">Home</p>
          </div>
          <div class="menu-group-expand"></div>
        </div>
      </router-link> -->

      <!-- / Dashboard \ -->

      <router-link tag="div" class="menu-group first small"  :to="`/dashboard`">
        <div class="menu-group-summary">
          <div class="menu-group-summary-icon">
            <v-icon :color="$vuetify.theme.themes[theme].text">speed</v-icon>
          </div>
          <div class="menu-group-summary-text">
            <p class="menu-group-name">Dashboard</p>
          </div>
          <div class="menu-group-expand"></div>
        </div>
      </router-link>

      <!-- \ Dashboard / -->

      

      <!-- / Flow \ -->

      <router-link tag="div" class="menu-group small"  v-if=" userRole == 'superadmin' && !demoMode" :to="`/flow`">
        <div class="menu-group-summary">
          <div class="menu-group-summary-icon">
            <v-icon :color="$vuetify.theme.themes[theme].text">mdi-source-branch</v-icon>
          </div>
          <div class="menu-group-summary-text">
            <p class="menu-group-name">Flow</p>
          </div>
          <div class="menu-group-expand"></div>
        </div>
      </router-link>

      <!-- \ Flow / -->

      <!-- / Qcare \ -->

      <div class="menu-group" :class="{ 'collapsed': menuAdminCollapsed}"  v-if=" (userRole == 'superadmin' && !demoMode) || companyQcare">
        <div class="menu-group-summary" @click="clickMenuItemAdmin()">
          <div class="menu-group-summary-icon">
            <v-icon :color="$vuetify.theme.themes[theme].text">mdi-format-list-checkbox</v-icon>
          </div>
          <div class="menu-group-summary-text">
            <p class="menu-group-name">Qcare</p>
            <p class="menu-group-summary-items">Overzicht en instellingen</p>
          </div>
          <div class="menu-group-expand">
            <v-icon :color="$vuetify.theme.themes[theme].text" v-if="menuReviewsCollapsed && $store.state.menuOpen">keyboard_arrow_down</v-icon>
            <v-icon :color="$vuetify.theme.themes[theme].text" v-else-if="!menuReviewsCollapsed && $store.state.menuOpen">keyboard_arrow_down</v-icon>
            <v-icon :color="$vuetify.theme.themes[theme].text" v-else>keyboard_arrow_right</v-icon>
          </div>
        </div>

        <div class="menu-group-items-wrapper">
          <div class="menu-group-items">
            <div class="menu-mobile-header" v-if="!$store.state.menuOpen">Qcare</div>
            <router-link tag="div" class="menu-group-item" :to="`/qcare`" @click.native="closeMenuExtentions()">
              <div class="menu-item-icon">
                <v-icon :color="$vuetify.theme.themes[theme].text" small>mdi-calendar</v-icon>
              </div>
              <div class="menu-item-text">Overzicht</div>
            </router-link>

            <router-link tag="div" class="menu-group-item" :to="`/qcare-settings`" @click.native="closeMenuExtentions()">
              <div class="menu-item-icon">
                <v-icon :color="$vuetify.theme.themes[theme].text" small>mdi-cog</v-icon>
              </div>
              <div class="menu-item-text">Instellingen</div>
            </router-link>
      
          </div>
        </div>
      </div>

      <!-- \ Qcare  / -->


      <!-- / Admin \ -->

      <div class="menu-group" :class="{ 'collapsed': menuAdminCollapsed}"  v-if=" userRole == 'superadmin' && !demoMode">
        <div class="menu-group-summary" @click="clickMenuItemAdmin()">
          <div class="menu-group-summary-icon">
            <v-icon :color="$vuetify.theme.themes[theme].text">build</v-icon>
          </div>
          <div class="menu-group-summary-text">
            <p class="menu-group-name">Onderhoud</p>
            <p class="menu-group-summary-items">Aansluitingen, Gebruikers en Logs</p>
          </div>
          <div class="menu-group-expand">
            <v-icon :color="$vuetify.theme.themes[theme].text" v-if="menuReviewsCollapsed && $store.state.menuOpen">keyboard_arrow_down</v-icon>
            <v-icon :color="$vuetify.theme.themes[theme].text" v-else-if="!menuReviewsCollapsed && $store.state.menuOpen">keyboard_arrow_down</v-icon>
            <v-icon :color="$vuetify.theme.themes[theme].text" v-else>keyboard_arrow_right</v-icon>
          </div>
        </div>

        <div class="menu-group-items-wrapper">
          <div class="menu-group-items">
            <div class="menu-mobile-header" v-if="!$store.state.menuOpen">Onderhoud</div>
            <router-link tag="div" class="menu-group-item" :to="`/popup`" @click.native="closeMenuExtentions()">
              <div class="menu-item-icon">
                <v-icon :color="$vuetify.theme.themes[theme].text" small>web_asset</v-icon>
              </div>
              <div class="menu-item-text">Popup</div>
            </router-link>

            <router-link tag="div" class="menu-group-item" :to="`/companies`" @click.native="closeMenuExtentions()">
              <div class="menu-item-icon">
                <v-icon :color="$vuetify.theme.themes[theme].text" small>business</v-icon>
              </div>
              <div class="menu-item-text">Aansluitingen</div>
            </router-link>
          
            <router-link tag="div" class="menu-group-item" :to="`/users`" @click.native="closeMenuExtentions()">
              <div class="menu-item-icon">
                <v-icon :color="$vuetify.theme.themes[theme].text" small>person</v-icon>
              </div>
              <div class="menu-item-text">Gebruikers</div>
            </router-link>

            <router-link tag="div" class="menu-group-item last" :to="`/log`" @click.native="closeMenuExtentions()">
              <div class="menu-item-icon">
                <v-icon :color="$vuetify.theme.themes[theme].text" small>notes</v-icon>
              </div>
              <div class="menu-item-text">Log</div>
            </router-link>
      
          </div>
        </div>
      </div>

      <!-- \ Admin  / -->

      
    </div>

    <div class="nav-fixed-buttom" :class="userRole">
      <div v-if="userRole === 'superadmin'" style="height: 40px;" class="text-center">
        <v-btn v-if="!demoMode" icon color="text" @click="setDemoMode(true)">
          <v-icon>play_arrow</v-icon>
        </v-btn>

        <v-btn v-if="demoMode" icon color="text" @click="setDemoMode(false)">
          <v-icon color="#FF4500">stop</v-icon>
        </v-btn>
      </div>
  
      <div style="height: 40px;" class="text-center">
        <v-tooltip right  v-if="theme == 'light'" >
          <template v-slot:activator="{ on }"> 
            <v-btn v-on="on" icon @click="setDarkTheme(true) ">
              <v-icon color="text">brightness_7</v-icon>
            </v-btn>
          </template>
          <span class="white--text">Applicatie weergeven in Darkmode</span>
        </v-tooltip>

        <v-tooltip right  v-if="theme == 'dark'">
          <template v-slot:activator="{ on }"> 
            <v-btn v-on="on"  icon color="text" @click="setDarkTheme(false)">
              <v-icon color="text">brightness_4</v-icon>
            </v-btn>
          </template>
          <span class="white--text">Applicatie weergeven in Lightmode</span>
        </v-tooltip>
      </div>
        

      <!-- <v-btn  @click="$vuetify.theme.dark = true">Dark</v-btn> -->

      <router-link tag="div" class="menu-group first small"  v-if="userRole === 'superadmin' || userRole === 'admin' || userRole === 'manager'" :to="`/algemene-instellingen`">
        <div class="menu-group-summary">
          <div class="menu-group-summary-icon">
            <v-icon size="18px" :color="$vuetify.theme.themes[theme].text" >settings</v-icon>
          </div>
          <div class="menu-group-summary-text">
            <p class="menu-group-name">Instellingen</p>
          </div>
          <div class="menu-group-expand"></div>
        </div>
      </router-link>

      <div class="menu-group small logout" :class="{ 'first' : userRole == 'employee'}" @click="logout()">
        <div class="menu-group-summary">
          <div class="menu-group-summary-icon">
            <v-icon size="18px" :color="$vuetify.theme.themes[theme].text" >lock</v-icon>
          </div>
          <div class="menu-group-summary-text">
            <p class="menu-group-name">Uitloggen</p>
          </div>
          <div class="menu-group-expand"></div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import lodash from "lodash";
import moment from "moment";
import { bus } from "../../main";
import db from "../../firebase/init";

export default {
  name: "Sidemenu",
  data: () => ({
    mini: true,
    showBatchQueue: false,
    showBatchPhotos: false,
    selectedBranches: [],
    clientQueue: [],
    clientPhotos: [],
    menuReviewsCollapsed: true,
    menuDossierCollapsed: true,
    menuAdminCollapsed: true,
    menuWidgetCollapsed: true,
    menuMessagesCollapsed: true,
    menuCompetentionCollapsed: true,
  }),

  created(){
    this.loadBranches()
    bus.$on("loadCompanyQueue", startDate =>{
      this.countQueueClients();
    })
     // Remember menu openings choice in Local Storage
    if(window.localStorage.getItem('menuCollapsed') == 'true'){
      this.$store.dispatch("menuStatus", false);
    } 
    else {
      window.localStorage.setItem('menuCollapsed', false);
      this.$store.dispatch("menuStatus", true);
    }

    // Remember pillarrrDarkmode choice in Local Storage
    if(window.localStorage.getItem('pillarrrDarkmode') == 'true'){
      this.setDarkTheme(true);
    } 
    else {
      window.localStorage.setItem('pillarrrDarkmode', false);
      this.setDarkTheme(false);
    }

    // Remember pillarrrDarkmode choice in Local Storage
    if(window.localStorage.getItem('pillarrrDemoMode') == 'true'){
      this.$store.dispatch("demoMode", true);
    } 
    else {
      window.localStorage.setItem('pillarrrDemoMode', false);
      this.$store.dispatch("demoMode", false);
    }
  },

  methods: {
    openMenu() {
      this.$store.dispatch("menuStatus", true);
      window.localStorage.setItem('menuCollapsed', false);
    },

    closeMenu() {
      this.$store.dispatch("menuStatus", false);
      window.localStorage.setItem('menuCollapsed', true);
      this.menuReviewsCollapsed = true;
      this.menuDossierCollapsed = true;
      this.menuAdminCollapsed = true;
      this.menuWidgetCollapsed = true;
      this.menuCompetentionCollapsed = true;
    },

    closeMenuExtentions(){
      // Close submenu layover when menu is collapsed
      if(!this.$store.state.menuOpen){
        this.menuReviewsCollapsed = true;
        this.menuDossierCollapsed = true;
        this.menuAdminCollapsed = true;
        this.menuWidgetCollapsed = true;
        this.menuCompetentionCollapsed = true;
      }
    },

    setDarkTheme(value){
      this.$vuetify.theme.dark = value
      window.localStorage.setItem('pillarrrDarkmode', value);
    },

    setDemoMode(value){
      window.localStorage.setItem('pillarrrDemoMode', value);
      this.$store.dispatch("demoMode", value);
    },

    clickMenuItemMessages(){
      if(this.menuMessagesCollapsed == true){
        this.menuMessagesCollapsed = false;
        if(!this.$store.state.menuOpen){
          this.menuReviewsCollapsed = true;
          this.menuDossierCollapsed = true;
          this.menuAdminCollapsed = true;
          this.menuCompetentionCollapsed = true;
          this.menuWidgetCollapsed = true;
        }
      } else{
        this.menuMessagesCollapsed = true;
      }
    },
    clickMenuItemWidget(){
      if(this.menuWidgetCollapsed == true){
        this.menuWidgetCollapsed = false;
        if(!this.$store.state.menuOpen){
          this.menuReviewsCollapsed = true;
          this.menuDossierCollapsed = true;
          this.menuAdminCollapsed = true;
          this.menuCompetentionCollapsed = true;
        }
      } else{
        this.menuWidgetCollapsed = true;
      }
    },

    clickMenuItemCompetention(){
      if(this.menuCompetentionCollapsed == true){
        this.menuCompetentionCollapsed = false;
        if(!this.$store.state.menuOpen){
          this.menuReviewsCollapsed = true;
          this.menuDossierCollapsed = true;
          this.menuAdminCollapsed = true;
          this.menuWidgetCollapsed = true;
          this.menuMessagesCollapsed = true;
        }
      } else{
        this.menuCompetentionCollapsed = true;
        
      }
    },

    clickMenuItemReviews(){
      if(this.menuReviewsCollapsed == true){
        this.menuReviewsCollapsed = false;
        if(!this.$store.state.menuOpen){
          this.menuDossierCollapsed = true;
          this.menuAdminCollapsed = true;
          this.menuWidgetCollapsed = true;
          this.menuMessagesCollapsed = true;
          this.menuCompetentionCollapsed = true;
        }
      } else{
        this.menuReviewsCollapsed = true;
      }
    },

    
    clickMenuItemDossier(){
      if(this.menuDossierCollapsed == true){
        this.menuDossierCollapsed = false;
        if(!this.$store.state.menuOpen){
          this.menuReviewsCollapsed = true
          this.menuAdminCollapsed = true;
          this.menuWidgetCollapsed = true;
          this.menuMessagesCollapsed = true;
          this.menuCompetentionCollapsed = true;
        }
      } else{
        this.menuDossierCollapsed = true;
      }
    },

    clickMenuItemAdmin(){
      if(this.menuAdminCollapsed == true){
        this.menuAdminCollapsed = false;
        if(!this.$store.state.menuOpen){
          this.menuReviewsCollapsed = true;
          this.menuDossierCollapsed = true;
          this.menuWidgetCollapsed = true;
          this.menuMessagesCollapsed = true;
          this.menuCompetentionCollapsed = true;
        }
      } else{
        this.menuAdminCollapsed = true;
      }
    },

    logout() {
      this.$store.dispatch("userLogout");
    },

    loadBranches() {
      this.selectedBranches = [];

      if (this.userRole == "employee" || this.userRole == "manager") {
        if (this.userBranches.length > 0) {
          this.selectedBranches = this.userBranches;
        } 
      } else {
        db.collection("branches")
          .where("compId", "==", this.userCompany)
          .get()
          .then(snap => {
            snap.forEach(doc => {
              let branchCollection = doc.data();
              branchCollection.id = doc.id;
              this.selectedBranches.push(doc.id);
            });
          })
      }
    },
    

  },
  computed: {

    companyType(){
      return this.$store.state.companyType
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userAbb() {
      return this.$store.state.userAbb;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userBranches() {
      return this.$store.state.userBranches;
    }, 

    userPermissions() {
      return this.$store.state.userPermissions;
    },
    companyType() {
      return this.$store.state.companyType;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },
    companyPackages() {
      return this.$store.state.companyPackages;
    },
    companyTrials() {
      return this.$store.state.companyTrials;
    },
    companyNarrowcasting() {
      if (this.companyPackages.indexOf("narrowcasting") >= 0) {
        return true;
      } else {
        return false;
      }
    },
    companyJourney() {
      if(this.companyPackages.indexOf("customerjourney") >= 0){
        return true;
      } else {
        return false;
      }
    },

    companyDossierPhotos() {
      if (this.companyPackages.indexOf("dossierphotos") >= 0) {
        return true;
      } else {
        return false;
      }
    },
    companyQcare() {
      if (this.companyPackages.indexOf("qcare") >= 0) {
        return true;
      } else {
        return false;
      }
    },

    companyDossier(){
      let active = false; 
      if( this.companyPackages && this.companyPackages.indexOf('dossier') >= 0){
        active = true;
      }
      else{
        // Package not purchased, check for active trial
        if(this.companyTrials && this.companyTrials.length > 0){
          this.companyTrials.forEach(trailPackage =>{
            if(trailPackage.id == 'dossier'){
              // Trial found, check if trialperiod is still active
              if(moment(trailPackage.trialStartDate).add(trailPackage.trialDays, 'days') > moment()){
                active = true;
              }
            }
          })
        }
      }
      return active
    },

    companyJourney(){
      let active = false; 

      if( this.companyPackages && this.companyPackages.indexOf('customerjourney') >= 0){
        active = true;
      }
      else{
        // Package not purchased, check for active trial
        if(this.companyTrials && this.companyTrials.length > 0){
          this.companyTrials.forEach(trailPackage =>{
            if(trailPackage.id == 'customerjourney'){
              // Trial found, check if trialperiod is still active
              if(moment(trailPackage.trialStartDate).add(trailPackage.trialDays, 'days') > moment()){
                active = true;
              }
            }
          })
        }
      }
      return active
    },

    companyConversion() {
      let active = false; 
      if (this.companyPackages.indexOf("conversion") >= 0) {
        active = true;
      } 
      else{
        // Package not purchased, check for active trial
        if(this.companyTrials && this.companyTrials.length > 0){
          this.companyTrials.forEach(trailPackage =>{
            if(trailPackage.id == 'conversion'){
              // Trial found, check if trialperiod is still active
              if(moment(trailPackage.trialStartDate).add(trailPackage.trialDays, 'days') > moment()){
                active = true;
              }
            }
          })
        }
      }
    
      return active;
      
    },
    companyCallcenter() {
      if (this.$store.state.userRole == 'superadmin' || (_.includes(this.companyPackages, "callcenter" && (this.$store.state.userCallCenterCompanies && this.$store.state.userCallCenterCompanies.length > 0)))) {
        return true;
      } else {
        return false;
      }
    },

    userCompanyName(){
      return this.$store.state.userCompanyName;
    },

    companyBarometers() {
      if (this.companyPackages.indexOf("barometers") >= 0) {
        return true;
      } else {
        return false;
      }
    },
    demoMode(){
      return this.$store.state.demoMode;
    }
  }
};
</script>


<style>

.menu-top {
  height: 47px;
  width: 100%;
  background-color: var(--v-background-base);
}

.menu-top-icon {
  padding: 14px 23px 0 23px;
  height: 44px;
}

.menu-mobile-header{
 font-weight: 600;
 font-size: 16px;
 padding: 5px 5px 5px 15px;
}

#menu-wrapper .menu-item {
  height: 44px;
  background: var(--v-menu-base);
  border-top: 1px solid var(--v-menuborder-base);
}

.menu-user-info{
  border-top: 1px solid var(--v-menuborder-base);
  padding: 0 10px;
  background-color: var(--v-menu-base);
}

.user-icon {
  float: left;
  width: 36px;
  height: 36px;
  border-radius: 40px;
  overflow: hidden;
  margin: 0 0 0 5px;
}

#menu-wrapper.menu-expanded .user-icon {
  width: 40px;
  height: 40px;
   margin: 0 10px 0 0;
}

.user-icon p {
  font-family: "Sofia Pro", sans-serif;
  font-size: 18px;
  text-align: center;
  text-transform: uppercase;
  padding: 6px 0 0 0;
  height: 36px;
}

#menu-wrapper.menu-expanded .user-icon p {
  font-size: 20px;
  padding: 8px 0 0 0;
  height: 40px;
}

.user-info{
  float: left;
  width: calc(100% - 60px);
  display: none;
}

#menu-wrapper.menu-expanded .user-info{
  display: block;
}

.user-info-name{
  font-weight: 600;
}
.menu-group{
  position: relative;
}

.menu-group.first{
  border-top: 1px solid var(--v-menuborder-base);
}

.menu-group{
  border-bottom: 1px solid var(--v-menuborder-base);
  background-color: var(--v-menuhover-base); 
}
.menu-group.small,
.menu-group.collapsed{
  background-color: var(--v-menu-base);
}
.menu-group-summary,
.menu-group.small .menu-group-summary,
#menu-wrapper.menu-expanded .menu-group.small .menu-group-summary{
  padding: 10px 0 10px 10px;
}

#menu-wrapper.menu-expanded .menu-group-summary{
  padding: 15px 10px;
}

.menu-group-summary-text{
  display: none;
}

#menu-wrapper.menu-expanded .menu-group-summary-text{
  display: block;
  width: 200px;
  height: 25px;
  float: left;
}

.menu-group-summary-icon i.v-icon{
  font-size: 22px!important;
}

#menu-wrapper.menu-expanded .menu-group-summary-icon i.v-icon{
  font-size: 18px!important;
}

.menu-group-summary:hover{
  background: var(--v-menuhover-base);
  cursor: pointer;
}

.menu-group-name{
  color: var(--v-text-base);
  font-weight: 600;
  font-size: 14px;
  margin: 0!important;
}

.menu-group .menu-group-summary-items{
  display: none;
}

.menu-group.collapsed .menu-group-summary-items{
  display: block;
  color: var(--v-text-base);
  font-weight: 400;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.menu-group-item,
.menu-group-summary:after{
  display: block;
  content:"";
  clear: both;
}

.menu-group-summary-icon{
  display: block;
  width: 25px;
  height: 25px;
  float: left;
  padding: 3px 0 0 0;
  margin: 0 0 0 12px;
}

#menu-wrapper.menu-expanded .menu-group-summary-icon{
  display: block;
  width: 25px;
  height: 25px;
  float: left;
  padding: 3px 0 0 0;
  margin: 0;
}

.menu-group.collapsed .menu-group-summary-text{
  height: 36px;
}

.menu-group-expand i.v-icon{
  font-size: 20px!important
}

#menu-wrapper.menu-expanded .menu-group-expand i.v-icon{
  font-size: 24px!important
}

.menu-group-expand{
  width: 20px;
  height: 25px;
  float: left;
  padding: 4px 2px 0 2px;
}

#menu-wrapper.menu-expanded .menu-group.collapsed .menu-group-expand{
  height: 36px;
}

.menu-group.collapsed .menu-group-items,
#menu-wrapper.menu-expanded .menu-group.collapsed .menu-group-items{
  display: none;
  height: 0;
  padding: 0;
}
.menu-group-items-wrapper{
  position: fixed;
}

#menu-wrapper.menu-expanded .menu-group-items-wrapper{
  position: relative;
}

.menu-group-items{
  position: absolute;
  height: auto;
  left: 80px;
  top: -45px;
  width: 250px;
  z-index: 999;
  background-color: var(--v-menu-base);
  text-overflow: ellipsis;
  white-space: nowrap;
  box-shadow: 0px 0px 15px rgba(0,0,0,0.1);;
}

.menu-group-items:before{
  position: absolute;
  display: block;
  left: -16px;
  content: "";
  top: 14px;
  height: 10px;
  width: 10px;
  border: 8px solid var(--v-menu-base);
  border-bottom-color: transparent;
  border-left-color: transparent;
  border-top-color: transparent;
 
}

#menu-wrapper.menu-expanded .menu-group-items{
  position: relative;
  height: auto;
  left: 0;
  top: 0;
  width: 100%;;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 0 15px 0;
  box-shadow: none;
}

#menu-wrapper.menu-expanded .menu-group-items::before{
  display: none;
}

.menu-group-item{
  height: 32px;
  padding: 6px 0;
}

.menu-group-item:hover{
  background-color: var(--v-menuhover-base);
  cursor: pointer;
}
.menu-group-item.router-link-exact-active,
.menu-group.small.router-link-exact-active{
  background-color: var(--v-menuhover-base)
}

.menu-group-item .menu-item-icon{
  width: 40px;
  padding: 0 10px 0 15px;
  height: 20px;
  float: left;
}

.menu-group-item .menu-item-text{
  width: calc(100% - 40px);
  height: 20px;
  float: left;
  font-size: 14px;
  font-weight: 300;
  color: var(--v-text-base);
}

.custom-menu-icon{
  width: 18px;
  height: 18px;
}

.menu-user-info.router-link-exact-active{
  background-color: var(--v-menuhover-base);
}

.menu-user-info,
.menu-group,
.menu-group-items,
.menu-group-item,
.menu-item-text{
-webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently */
}

.nav-fixed-buttom{
  position: absolute;
  bottom: 0;
  height: 133px;
  width: 100%;
}
.nav-fixed-buttom.superadmin{
  height: 173px;
}

#menu-wrapper.menu-expanded .nav-scroll{
  width: 274px;
}

.nav-scroll{
  position: absolute;
  overflow-y: scroll;
  overflow-x: scroll;
  top: 47px;
  overflow: hidden;
  width: 69px;
  height: calc(100% - 181px);
  padding: 0 0 15px 0;
}



.nav-scroll.superadmin{
  height: calc(100% - 221px);
}

.nav-scroll::-webkit-scrollbar {
    display: none;
}

.menu-group.small .menu-group-expand{
  display: none;
}

.logout{
  position: absolute;
  bottom: 0;
  width: 100%;
}

.logo-4care-menu{
  float: left;
  width: 180px;
  height: 47px;
  background: url("../../assets/4caretelecom-logo.png") no-repeat left center;
  background-size: auto 35px;
}

.logo-4care-menu.dark{
  background: url("../../assets/4caretelecom-logo-dark.png") no-repeat left center;
  background-size: auto 35px;
}


</style>

